import React, { useState } from 'react';
import ContactForm from './formdata/ContactForm';
const ContactRM = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [statusMessage, setStatusMessage] = useState({ type: '', message: '' }); 
  const apiBase = process.env.REACT_APP_API_BASE_URL;
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    contact: '',
    address: '',
    message: '',
  });
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
  e.preventDefault();

  const { name, email, contact, address, message } = formData;
  if (!name.trim() || !email.trim() || !contact.trim() || !address.trim() || !message.trim()) {
    setStatusMessage({ type: "error", message: "Please fill in all required fields." });
    return;
  }

  setIsSubmitting(true);

  try {
    const res = await fetch(`${apiBase}/contact`, {

      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });

    const result = await res.json();

    if (res.ok) {
      setStatusMessage({ type: "success", message: result.message });
      setFormData({ name: "", email: "", contact: "", address: "", message: "" });
    } else {
      setStatusMessage({ type: "error", message: result.message || "Submission failed." });
    }
  } catch (error) {
    console.error("Submit error:", error);
    setStatusMessage({ type: "error", message: "Server error. Please try again later." });
  } finally {
    setIsSubmitting(false);
  }
};


  return (
    <div>
      <ContactForm formData={formData} handleChange={handleChange} handleSubmit={handleSubmit} isSubmitting={isSubmitting}  statusMessage={statusMessage} />
    </div>
  );
};

export default ContactRM;